<template>
  <div class="editor">

     <!-- 自定义提示框 -->
      <div class="alsrtInfo" :style="{display: displayStsates}" ref="alertMsg">
        <div class="profPrompt_test">{{aletMsg}}</div>
      </div>

    <div class="address_title">
      <div class="address_title_left" v-on:click="xreturn">
        <img src="../../images/dir_left.png" />
      </div>新增地址
    </div>

    <div class="editor_div">
      <div>
        <div>店铺名称</div>
        <input maxlength="7" placeholder="请输入收货人姓名" v-model:value="parameter.name" />
      </div>
      <div>
        <div>手机号</div>
        <input
          maxlength="11"
          type="text"
          onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
          placeholder="请输入收货人手机号"
          v-model:value="parameter.phone"
        />
      </div>
      <div>
        <div>选择地区</div>
        <input
          type="text"
          style="width: 55%;"
          v-model="carmodel"
          value
          readonly
          v-model:value="parameter.region"
          placeholder="请选择所在地区"
        />
        <div class="region_list">
          <span id="region" @click="show = true"></span>
        </div>
      </div>
      <div>
        <div>详细地址</div>
        <input placeholder="街道，楼牌号等" v-model:value="parameter.nexadders" />
      </div>
      <div style="text-align: right;line-height: 0.98rem;">
        <div style="float: left;text-align: left;">设置默认地址</div>
        <van-switch class="list" v-model="checked" size="24px" />
      </div>
    </div>

    <van-cell-group>
      <!--cell+popup+area省市区的坑-->
      <van-popup v-model="show" position="bottom">
        <van-area
          ref="area"
          value="110000"
          :area-list="areaList"
          @change="onChange"
          @confirm="show = false"
          @cancel="show = false"
        />
      </van-popup>
    </van-cell-group>

    <button class="but" v-on:click="save">保存地址</button>
  </div>
</template>

<script>
import API from "../../lmj_Api/api";

import areaObj from "../commonality/address3.js";
import { Cell, CellGroup, Popup, Field, Area, Picker } from "vant";
export default {
  components: {
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanPopup: Popup,
    VanField: Field,
    VanArea: Area,
    VanPicker: Picker
  },
  data() {
    return {
      name: "addresseditor",
      uid: this.$store.getters.get_user_id,
      carmodel: "",
      //三联地区存储
      areaList: {
        province_list: areaObj.province_list,
        city_list: areaObj.city_list,
        county_list: areaObj.county_list
      },
      // 输入框的值
      parameter: {
        name: "",
        phone: "",
        region: "",
        nexadders: ""
      },
      // 开关的状态
      checked: true,
      show: false,
      show1: false,
      aletMsg: "", // 弹框提示语
      displayStsates: "none"
    };
  },

  methods: {
    // 拼接三联地区
    onChange(picker, value, index) {
       var i,
           off = true;
      this.parameter.region = "";
      for (var i = 0; i < value.length; i++) {
        if (value[0].name == value[1].name && i < 2) {
          this.parameter.region += "-" + value[i + 1].name;
          off = false;
        } else if (off) {
          off = true;
          this.parameter.region += "-" + value[i].name;
        }
      }
      this.parameter.region = this.parameter.region.substring(1, this.parameter.region.length)
    },

    // 添加地址
    save() {
      var that = this;
      var status = 0;
      if (this.checked == true) {
        status = 1;
      }
      this.axios
        .post(API.addressSave, {
          name: this.parameter.name,
          phone: this.parameter.phone,
          addr: this.parameter.region,
          address: this.parameter.nexadders,
          default: status,
          user_id: this.uid
        })
        .then(res => {
            this.alertDia(res.data.msg);

          if (res.data.code == 200) {
            // this.alertDia(res.data.msg);
            window.setTimeout(()=>{
               this.$router.push({ path: "/addressmanagement" });
            },1100);
          }
        });
    },

    xreturn() {
      // this.$router.go(-1);
       this.$router.push({path:'/addressmanagement'})
    },

    // 提示框
    alertDia(msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 1000);
    },
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}


// 提示框
  .alsrtInfo {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    .profPrompt_test {
    width: 4.2rem;
    height: 1.4rem;
    line-height: 1.4rem;
    border-radius: 0.2rem;
    color: #FFF;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0.6;
    top: 5.98rem;
    left: 50%;
    font-size: 0.28rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    opacity: 1;
    text-align: center;
    transform: translate(-50%, -50%);
    }
  }

input {
  border: 0;
  background: transparent;
  outline: none;
  margin: 0;
  padding: 0;
}
input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(216, 216, 216, 1);
}

input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(216, 216, 216, 1);
}

input:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(216, 216, 216, 1);
}

input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(216, 216, 216, 1);
}

.address_title {
  width: 7.5rem;
  height: 0.88rem;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 0.88rem;
  position: relative;
}

.address_title > div {
  position: absolute;
  top: 0rem;
  text-align: center;
}

.address_title > div > img {
  width: 0.18rem;
  height: 0.34rem;
  display: inline-block;
  vertical-align: middle;
}

.address_title > .address_title_left {
  left: 0rem;
  width: 1.06rem;
  height: 100%;
  line-height: 0.88rem;
}

.address_title > .address_title_right {
  right: 0rem;
  width: 1.12rem;
  height: 100%;
  line-height: 0.88rem;
}

.address_title > .address_title_right > img {
  width: 0.36rem;
  height: 0.38rem;
  display: inline-block;
  vertical-align: middle;
}

.editor_div > div {
  width: 6.72rem;
  margin: auto;
  border-bottom: 0.01rem solid rgba(239, 239, 239, 1);
  height: 0.98rem;
}

.editor_div > div > div {
  // display: inline-block;
  width: 1.9rem;
  line-height: 0.98rem;
  height: 0.98rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(99, 99, 99, 1);
  // vertical-align: top;
  float: left;
}

.editor_div > div > input {
  float: left;
  height: 0.98rem;
  vertical-align: top;
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(99, 99, 99, 1);
  width: 4.8rem;
}
.editor_div > div > input::-ms-input-placeholder {
  color: rgba(216, 216, 216, 1);
}

#region {
  display: inline-block;
  width: 0.8rem;
  height: 0.32rem;
}

#pass_img1 {
  // background: url("../../images/画板备份 6.png") 0.28rem 0.06rem no-repeat;
  background-size: 40%;
}

#pass_img2 {
  // background: url("../../images/形状结合备份.png") 0.24rem 0.07rem no-repeat;
  background-size: 40%;
}

#region {
  border-left: 0.04rem solid white;
  background: url("../../images/list_bottom.png") 0.27rem 0.03rem no-repeat;
  background-size: 40%;
}

.editor_div > div > .region_list {
  float: right;
  text-align: right;
  width: 15%;
}



	.editor_div>div>.list {
		height: 0.56rem;
		width: 1rem;
	  float: right;
	  margin-top: 0.15rem;
	}

	.editor_div>div>.list>div {
		margin: 0.01rem;
		height: 0.55rem;
		width: 0.55rem;
	}

.van-switch--on {
  background: #4bd863;
}

.but {
  width: 100%;
  height: 1.08rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 1.08rem;
  border: 0rem;
  border-radius: 0rem;
  position: fixed;
  bottom: 0rem;
  left: 0rem;
  color: rgba(255, 255, 255, 1);
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/xy/nwaddress.vue